import { useState } from "react";
import { api } from "@/lib/api";
import { Sparkles } from "lucide-react";

export default function ExecStorytelling() {
  const [board, setBoard] = useState(null);
  const [value, setValue] = useState(null);
  const [busy, setBusy] = useState(false);

  const gen = async (kind) => {
    setBusy(true);
    try {
      if (kind === "board") { const r = await api.post("/ai/board-summary"); setBoard(r.data); }
      else { const r = await api.post("/ai/business-value"); setValue(r.data); }
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Executive Storytelling AI</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Board · Business · Renewal Narratives</h1>
        <p className="text-sm text-zinc-500 mt-1">GPT-5.2 cited with live metrics — drives commercial conversations.</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card title="Board Summary" cta="Generate Board Summary" onClick={()=>gen("board")} busy={busy} testid="story-board" text={board?.text}/>
        <Card title="Business Value Report" cta="Generate Value Report" onClick={()=>gen("value")} busy={busy} testid="story-value" text={value?.text}/>
      </div>
    </div>
  );
}

function Card({ title, cta, onClick, busy, text, testid }) {
  return (
    <div className="bg-zinc-950 border border-zinc-900 rounded-md p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2"><Sparkles size={14} className="text-blue-400"/><div className="font-display font-medium">{title}</div></div>
        <button onClick={onClick} disabled={busy} data-testid={testid} className="bg-blue-600 hover:bg-blue-700 text-white text-xs rounded px-3 py-1.5">{busy?"Generating…":cta}</button>
      </div>
      {text ? <pre className="text-xs whitespace-pre-wrap text-zinc-300 leading-relaxed max-h-96 overflow-auto" data-testid={`${testid}-output`}>{text}</pre>
      : <div className="text-sm text-zinc-500">Click generate to produce executive-grade narrative.</div>}
    </div>
  );
}
